import { LegacyPagePaths } from "App/routes/paths";
import { JourneysPaths } from "Pages/orchestration/Pages/journeys/paths";

import { JourneysIndex } from ".";
import { orchestrationPathResources } from "../orchestrationPaths";
import { JourneyEditPage } from "./JourneyEditPage/JourneyEditPage";
import JourneysRouter, { JourneysRerouter } from "./JourneysRouter";

import type { RegalRouteObject } from "App/routes/types";
export const journeysRoute: RegalRouteObject = {
    path: `/${orchestrationPathResources.journeys}`,
    element: <JourneysRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <JourneysIndex />,
        },
        {
            path: JourneysPaths.edit,
            element: <JourneyEditPage />,
        },
    ],
};

export const rerouteJourneysRoute: RegalRouteObject = {
    path: LegacyPagePaths.journeys,
    element: <JourneysRerouter />,
    children: [
        {
            path: "*",
            element: <JourneysRerouter />,
        },
    ],
};
